import React from 'react';

export interface ViewHeaderProps {
  eyebrow: string;
  title: string;
  subtitle?: string;
  className?: string;
}

export function ViewHeader({
  eyebrow,
  title,
  subtitle,
  className,
}: ViewHeaderProps): React.JSX.Element {
  return (
    <div className={`view-header${className ? ` ${className}` : ''}`}>
      <div className="view-header-eyebrow">{eyebrow}</div>
      <h1 className="view-header-title">{title}</h1>
      {subtitle && <p className="view-header-subtitle">{subtitle}</p>}
    </div>
  );
}
